import { ReservationDocument } from '@appTypes/api.types';

/**
 * What the cabinet needs from the API to draw one tourist's insurance line (docs features/insurance-service/qa.md, "Stage 2 - website cabinet",
 * R-52; step A7). The API adds the block to a document of type `Insurance` ONLY while the policy engine is `InsuranceService`; a document
 * without it is the classic line (Type | Description | Download) and is drawn exactly as before - that is the A7 revert.
 */
export interface ReservationInsuranceDocument {
  /** The tourist the line is for; also the suffix of every test id of the line. Falls back to the `documentId` of the document URL. */
  touristId?: string | null;
  /** `Draft` = not issued yet, `InProcess` = being issued right now (by the operator or another agent), `Confirmed` = issued. */
  status?: ReservationInsuranceStatus | null;
  /** The policy number once issued. */
  policyNumber?: string | null;
  /** The issue day, ISO `yyyy-MM-dd` (an ISO date-time is cut to its day); the screen shows it as dd.mm.yyyy. */
  issueDate?: string | null;
  /** The operator issued the policy in New RF (R-37 / R-52): the cabinet shows the same policy and no Create button. */
  issuedByOperator?: boolean | null;
}

export type ReservationInsuranceStatus = 'Draft' | 'InProcess' | 'Confirmed';

/** A reservation document, with the insurance block the API adds under the engine `InsuranceService`. */
export type InsuranceAwareDocument = ReservationDocument & { insurance?: ReservationInsuranceDocument | null };

/** Coded answers of the issue action (R-52, A5) the cabinet draws a state for; any other code gets the generic coded message. */
export const INSURANCE_ISSUE_IN_PROGRESS = 'INSURANCE_ISSUE_IN_PROGRESS';
export const INSURANCE_PROVIDER_REFUSED = 'INSURANCE_PROVIDER_REFUSED';
export const INSURANCE_TOURIST_DATA_INVALID = 'INSURANCE_TOURIST_DATA_INVALID';
export const INSURANCE_REGISTRATION_PENDING = 'INSURANCE_REGISTRATION_PENDING';
export const INSURANCE_SERVICE_UNAVAILABLE = 'INSURANCE_SERVICE_UNAVAILABLE';
